module.exports = __webpack_public_path__ + "static/media/majorB1.f5ef289.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB1.wav
// module id = 8T+c
// module chunks = 0